import { FC, useCallback } from 'react';
import { FILTER_KEY, FILTER_NAME, FILTER_NAME_REDESIGN } from './constants';
import { useModalState, useShowSearchMetaTooltip } from 'shared/hooks';
import { SearchResultsTooltip } from 'shared/components/SearchResultsTooltip';
import { AdvancedFiltersModalContainer } from './containers';
import { AdvancedFiltersButton } from 'shared/components/AdvancedFiltersButton';
import { AdvancedFiltersButtonV2 } from 'shared/components/AdvancedFiltersButtonV2';
import { useSelector } from 'react-redux';
import { selectIsSomeAdvancedFiltersSelected } from 'shared/selectors/advancedFilters';
import { trackShowAdvancedFiltersClick } from './tracking';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';

export const AdvancedFiltersContainer: FC = () => {
  const { opened, onOpen, onClose } = useModalState();

  const handleOpen = useCallback(() => {
    onOpen();
    trackShowAdvancedFiltersClick();
  }, [onOpen]);

  const showSearchMetaTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const isSomeAdvancedFiltersSelected = useSelector(selectIsSomeAdvancedFiltersSelected);

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  return (
    <>
      <SearchResultsTooltip open={showSearchMetaTooltip} placement="bottom-start">
        {isFiltersRedesignEnabled ? (
          <AdvancedFiltersButtonV2 onClick={handleOpen} showBadge={!opened && isSomeAdvancedFiltersSelected}>
            {FILTER_NAME_REDESIGN}
          </AdvancedFiltersButtonV2>
        ) : (
          <AdvancedFiltersButton onClick={handleOpen} showBadge={!opened && isSomeAdvancedFiltersSelected}>
            {FILTER_NAME}
          </AdvancedFiltersButton>
        )}
      </SearchResultsTooltip>
      {opened && <AdvancedFiltersModalContainer isRedesignEnabled={isFiltersRedesignEnabled} onClose={onClose} />}
    </>
  );
};
